import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './terminDetailMobileItem.scss';

interface Props {
  definicia: string,
  zdroj: string,
  link?: string,
  headerDefinicia: string,
  headerZdroj: string,
}

const TerminDetailMobileItem = ({
  definicia,
  zdroj,
  link = '',
  headerDefinicia,
  headerZdroj,
}: Props): ReactElement => (
  <Col className="dokument-detail">
    <Row className="dokument-detail-row">
      <Text type="div" className="information-header">
        <div className="information-header-row">
          {headerDefinicia}
        </div>
      </Text>
      <Text type="div" className="dokument-detail-row-text">{definicia}</Text>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="div" className="information-header">
          <div className="information-header-row">
            {headerZdroj}
          </div>
        </Text>
      </div>
      <div className="one-half">
        {link === '' ? (
          <Text type="div" className="dokument-detail-row-text">{zdroj}</Text>
        ) : (
          <Link
            className="zdroj-legalnej-definicie-button-link"
            to={`${process.env.REACT_APP_PORTAL_MAIN_URL}/ezbierky/pravne-predpisy${link}`}
            onClick={() => {
              window.parent.postMessage(
                {
                  type: 'iframe-to-parent-external-route',
                  route: `/ezbierky/pravne-predpisy${link}`,
                },
                '*',
              );
            }}
          >
            {zdroj}
          </Link>
        )}
      </div>
    </Row>
  </Col>
);

export default TerminDetailMobileItem;
